import isNil from "lodash/isNil";
import isObject from "lodash/isObject";

function recursivelyOverride(target, source) {
  return Object.keys(source).reduce(
    (target, key) => {
      const sourceValue = source[key];

      if (sourceValue || sourceValue === 0) {
        target[key] = isObject(sourceValue)
          ? recursivelyOverride(target[key], sourceValue)
          : sourceValue;
      }

      return target;
    },
    { ...target }
  );
}

// A zoom level style can be defined with only one of its bounds, the other one being
// unbounded. The missing bound must be checked explicitly, as comparing a number with
// `null` casts it to 0, which would make a style without maximum never match.
const zoomLevelStyleMatches = (zoomLevel, { zoomLevelMin, zoomLevelMax }) =>
  (isNil(zoomLevelMin) || zoomLevel >= zoomLevelMin) &&
  (isNil(zoomLevelMax) || zoomLevel <= zoomLevelMax);

// Returns the style for a map element adapted to the current zoom level of the
// map
//
export default function getMapElementStyle(zoomLevel, style) {
  const zoomSpecificStyle = style.zoomLevels.find(zoomLevelStyle =>
    zoomLevelStyleMatches(zoomLevel, zoomLevelStyle)
  );

  // If there's no zoom level specific style for the current zoom level, we just
  // return the root style object from which every style attribute is contained
  if (!zoomSpecificStyle) return style;

  // Start with a copy of the style, iterate over each non-null
  // zoomSpecificStyle own properties and fill the final style object with
  // the zoom specific value
  const finalStyle = { ...style };
  delete finalStyle.zoomLevels;

  return recursivelyOverride(finalStyle, zoomSpecificStyle.style);
}
